import { forwardRef, useState } from 'react'
import { TabsContextProvider } from './context'
import classNames from 'classnames'
import type { CommonProps } from '../@types/common'
import type { TabsVariant, TabsValue } from './context'
import type { ReactNode } from 'react'

export interface TabsProps extends CommonProps {
    children?: ReactNode
    defaultValue?: TabsValue
    onChange?: (tabValue: TabsValue) => void
    value?: TabsValue
    variant?: TabsVariant
}

const Tabs = forwardRef<HTMLDivElement, TabsProps>((props, ref) => {
    const {
        className,
        children,
        defaultValue,
        onChange,
        value: valueProp,
        variant = 'underline',
        ...rest
    } = props

    const [value, setValue] = useState(valueProp || defaultValue)

    const onValueChange = (val: TabsValue) => {
        setValue(val)
        onChange?.(val)
    }

    const tabsClass = classNames('tabs', className)

    return (
        <TabsContextProvider
            value={{
                value: value,
                onValueChange,
                variant,
            }}
        >
            <div className={tabsClass} {...rest} ref={ref}>
                {children}
            </div>
        </TabsContextProvider>
    )
})

Tabs.displayName = 'Tabs'

export default Tabs 